import * as Kit from "../theme";

export const Box = Kit.styled("div");

type BoxProps = React.ComponentPropsWithRef<typeof Box>;

export type { BoxProps };
